import axios, { get, post } from '../../axios/axios';
import { absoluteUrl, downloadFile } from '../../utils/sseFetch';

// 网关路径；axios 拦截器会给 /ai/pptgen/... 自动带 X-Guest-Id（免登录，按设备归属）
const BASE = '/ai/pptgen';
// lgfb 的 get/post 会改写传入的 config，每次给一个新对象
const quiet = () => ({ slient: true });

function unwrap(res) {
    if (res?.code === 0) return res.data;
    const error = new Error(res?.msg || '请求失败，请稍后重试');
    error.response = { data: res };
    throw error;
}

export const pptApi = {
    status: () => get(`${BASE}/status`, {}, quiet()).then(unwrap),
    quote: () => get(`${BASE}/quote`, {}, quiet()).then(unwrap),
    categories: () => get(`${BASE}/categories`).then(unwrap),
    templates: (params) => get(`${BASE}/templates`, params).then(unwrap),
    uploadMaterial: (file, fields, onProgress) => {
        const form = new FormData();
        form.append('file', file);
        Object.entries(fields).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') form.append(key, value);
        });
        return post(`${BASE}/materials`, form, {
            onUploadProgress: (event) => {
                if (onProgress && event.total)
                    onProgress(Math.round((event.loaded / event.total) * 100));
            },
        }).then(unwrap);
    },
    rebuildMaterial: (uid) => post(`${BASE}/tasks/${uid}/material/rebuild`).then(unwrap),
    saveMaterial: (uid, material) =>
        axios.put(`${BASE}/tasks/${uid}/material`, material).then(unwrap),
    createTextTask: (payload) => post(`${BASE}/tasks`, payload).then(unwrap),
    submitFileTask: (uid, payload) => post(`${BASE}/tasks/${uid}/submit`, payload).then(unwrap),
    retry: (uid) => post(`${BASE}/tasks/${uid}/retry`).then(unwrap),
    cancelAutoSubmit: (uid) => post(`${BASE}/tasks/${uid}/auto-submit/cancel`).then(unwrap),
    task: (uid, { quiet = false } = {}) =>
        get(`${BASE}/tasks/${uid}`, {}, quiet ? { slient: true } : {}).then(unwrap),
    history: () => get(`${BASE}/tasks`, {}, quiet()).then(unwrap),
};

/** 后端返回的是网关相对路径（/ai/pptgen/...），<img> 直接用绝对地址，无需请求头 */
export const assetUrl = (path) => (path ? absoluteUrl(path) : '');

/** 下载导出文件（fetch + blob，带设备头）；失败时抛出带后端说明的错误 */
export const downloadExport = (path, fallbackName) => downloadFile(path, fallbackName);
